import { useContext } from "react";
import { ProductContext } from "../context/ProductContext";
import "./PregnancyCare.css";
import bgImage from "../assets/backgroundimage.jpg";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function PregnancyCare() {
  const { products } = useContext(ProductContext);
  const navigate = useNavigate();

  // ✅ FILTER CATEGORY
  const pregnancyProducts = products.filter(
    (item) => item.category === "pregnancy-care"
  );

  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>Pregnancy Care Products | ManuX NanoBioCeuticals</title>

        <meta
          name="description"
          content="Explore safe and natural pregnancy care products designed for mothers and babies. Ayurvedic and science-backed solutions."
        />

        <meta
          name="keywords"
          content="Pregnancy care, maternity products, herbal pregnancy, safe mother care"
        />

        <link rel="canonical" href="https://manuxnbc.com/pregnancy-care" />
      </Helmet>

      <div
        className="preg-page"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <h1 className="preg-title">Pregnancy Care 🤰</h1>

        <div className="preg-grid">
          {pregnancyProducts.length > 0 ? (
            pregnancyProducts.map((item) => (
              <div key={item._id} className="preg-card">

                {/* IMAGE */}
                <div className="preg-img-box">
                  <img
                    src={`${BASE_URL}/uploads/${item.image}`}
                    alt={`${item.name} - Pregnancy Care Product`}
                    onClick={() => navigate(`/product/${item._id}`)}
                  />
                </div>

                {/* CONTENT */}
                <div className="preg-content">
                  <h3>{item.name}</h3>

                  <p>
                    {item.description?.length > 80
                      ? item.description.substring(0, 80) + "..."
                      : item.description}
                  </p>

                  {item.description?.length > 80 && (
                    <button
                      className="view-btn"
                      onClick={() =>
                        navigate(`/product/${item._id}`)
                      }
                    >
                      View More
                    </button>
                  )}
                </div>

              </div>
            ))
          ) : (
            <p className="no-data">No Pregnancy Products Found</p>
          )}
        </div>
      </div>
    </>
  );
}